var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("jspdf"), require("html2canvas")) : "function" == typeof define && define.amd ? define(["jspdf", "html2canvas"], e) : "object" == typeof exports ? exports["jspdf-html2canvas"] = e(require("jspdf"), require("html2canvas")) : t.html2PDF = e(t.jspdf, t.html2canvas);
}(self, function (t, e) {
  return function () {
    "use strict";

    var n = {
      498: function _(t) {
        t.exports = e;
      },
      676: function _(e) {
        e.exports = t;
      }
    },
        o = {};

    function r(t) {
      var e = o[t];
      if (void 0 !== e) return e.exports;
      var a = o[t] = {
        exports: {}
      };
      return n[t](a, a.exports, r), a.exports;
    }

    r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, {
        a: e
      }), e;
    }, r.d = function (t, e) {
      for (var n in e) {
        r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: e[n]
        });
      }
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    };
    var a = {};
    return function () {
      r.d(a, {
        default: function _default() {
          return g;
        }
      });
      var t = r(676),
          e = r(498),
          n = r.n(e);

      var o = {
        jsPDF: {
          unit: "pt",
          format: "a4"
        },
        html2canvas: {
          imageTimeout: 15e3,
          logging: !0,
          useCORS: !1
        },
        margin: {
          right: 0,
          top: 0,
          bottom: 0,
          left: 0
        },
        imageType: "image/jpeg",
        imageQuality: 1,
        autoResize: !0,
        output: "jspdf-generate.pdf",
        watermark: void 0,
        init: function init() {},
        success: function success(t) {
          t.save(this.output);
        }
      },
          i = window.devicePixelRatio,
          f = {
        "image/jpeg": "JPEG",
        "image/png": "PNG",
        "image/webp": "WEBP"
      },
          c = function c(t) {
        return f[t];
      },
          s = function s(t, e, n) {
        var o = e.pdf,
            r = e.pdfContentWidth,
            a = e.pdfContentHeight,
            f = e.pdfWidth,
            s = e.pdfHeight,
            p = e.position,
            d = e.currentPage,
            u = e.pageOfCurrentNode;

        var _ref = function (_ref2) {
          var t = _ref2.canvas,
              e = _ref2.pdf,
              n = _ref2.pdfContentWidth,
              o = _ref2.opts;
          var r = t.toDataURL(o.imageType, o.imageQuality),
              a = e.getImageProperties(r);
          return {
            pageData: r,
            printWidth: o.autoResize ? n : a.width / i,
            printHeight: o.autoResize ? n / a.width * a.height : a.height / i
          };
        }({
          canvas: t,
          pdf: o,
          pdfContentWidth: r,
          opts: n
        }),
            l = _ref.pageData,
            g = _ref.printWidth,
            m = _ref.printHeight;

        var h = m;
        p < 0 && (o.addPage(), d += 1, u = 1, p = 0);
        var v = n.margin;

        for (; h > 0;) {
          if (o.addImage(l, c(n.imageType), v.left, p + v.top * u + v.bottom * (u - 1), g, m), o.setFillColor(255, 255, 255), o.rect(0, 0, f, v.top, "F"), o.rect(0, s - v.bottom, f, v.bottom, "F"), h < a) {
            p -= h;
            break;
          }

          h -= a, p -= s, o.addPage(), d += 1, u += 1;
        }

        !function (t, e, n, o, r) {
          t.pdf = e, t.position = n, t.currentPage = o, t.pageOfCurrentNode = r;
        }(e, o, p, d, u);
      };

      var p = function p(t, e) {
        return n = this, o = void 0, a =
        /*#__PURE__*/
        _regeneratorRuntime.mark(function a() {
          return _regeneratorRuntime.wrap(function a$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = e.watermark;

                  if (!_context.t0) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return function (t, e) {
                    return new Promise(function (n) {
                      var o;

                      var r = new Image(),
                          a = "string" == typeof e.watermark ? e.watermark : "function" != typeof e.watermark && (null === (o = e.watermark) || void 0 === o ? void 0 : o.src),
                          i = function i() {
                        t.pdf = function (t, e) {
                          var n, o;
                          var r = t.internal.getNumberOfPages();
                          if ("function" == typeof e.watermark) for (var _n = 1; _n <= r; _n++) {
                            t.setPage(_n);
                            var _o = {
                              pdf: t,
                              pageNumber: _n,
                              totalPageNumber: r
                            };
                            e.watermark.call(e, _o);
                          } else if (e.watermarkImg) {
                            var _a = t.getImageProperties(e.watermarkImg),
                                _i = "string" != typeof e.watermark && (null === (n = e.watermark) || void 0 === n ? void 0 : n.scale) || 1;

                            for (var _n2 = 1; _n2 <= r; _n2++) {
                              if (t.setPage(_n2), "string" != typeof e.watermark && (null === (o = e.watermark) || void 0 === o ? void 0 : o.handler)) {
                                var _o2 = {
                                  pdf: t,
                                  pageNumber: _n2,
                                  totalPageNumber: r,
                                  imgNode: e.watermarkImg
                                };
                                e.watermark.handler.call(e, _o2);
                              } else t.addImage(e.watermarkImg, c("image/png"), (t.internal.pageSize.width - _a.width * _i) / 2, (t.internal.pageSize.height - _a.height * _i) / 2, _a.width * _i, _a.height * _i);
                            }
                          } else console.warn('[jspdf-html2canvas] "watermark" option should be either "string" or "function" type.');
                          return t;
                        }(t.pdf, e), n(null);
                      };

                      a ? (r.onload = function () {
                        e.watermarkImg = r, i();
                      }, r.crossOrigin = "Anonymous", r.src = a) : "function" == typeof e.watermark && i();
                    });
                  }(t, e);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, a, this);
        }), new ((r = void 0) || (r = Promise))(function (t, e) {
          function i(t) {
            try {
              c(a.next(t));
            } catch (t) {
              e(t);
            }
          }

          function f(t) {
            try {
              c(a.throw(t));
            } catch (t) {
              e(t);
            }
          }

          function c(e) {
            var n;
            e.done ? t(e.value) : (n = e.value, n instanceof r ? n : new r(function (t) {
              t(n);
            })).then(i, f);
          }

          c((a = a.apply(n, o || [])).next());
        });
        var n, o, r, a;
      };

      function d(t) {
        return null !== t && "object" == typeof t;
      }

      function u(t) {
        return "function" == typeof t;
      }

      function l(t, e) {
        for (var _n3 = 0, _o3 = Object.keys(t); _n3 < _o3.length; _n3++) {
          var _r = _o3[_n3];

          if (_r in e) {
            var _n4 = d(t[_r]),
                _o4 = d(e[_r]);

            _n4 && _o4 ? u(t[_r]) && u(e[_r]) ? u(t[_r]) && !u(e[_r]) ? console.error("[jspdf-html2canvas] config key \"".concat(_r, "\" type invalid")) : t[_r] = e[_r] : t[_r] = l(t[_r], e[_r]) : _o4 ? (e[_r].old = t[_r], t[_r] = e[_r]) : _n4 ? t[_r].new = e[_r] : t[_r] = e[_r], delete e[_r];
          }
        }

        return Object.assign(t, e);
      }

      var g = function g(e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return a = this, i = void 0, c =
        /*#__PURE__*/
        _regeneratorRuntime.mark(function c() {
          var a, i, _t, _o5, _t2;

          return _regeneratorRuntime.wrap(function c$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  a = l(o, r), i = function (e) {
                    var n = e.margin,
                        o = new t.jsPDF(e.jsPDF),
                        r = o.internal.pageSize.getWidth(),
                        a = o.internal.pageSize.getHeight();
                    return {
                      pdf: o,
                      pdfWidth: r,
                      pdfHeight: a,
                      pdfContentWidth: r - (n.left + n.right),
                      pdfContentHeight: a - (n.top + n.bottom),
                      position: 0,
                      currentPage: 1,
                      pageOfCurrentNode: 1
                    };
                  }(a);

                  if (!(a.init.call(a, i.pdf), "length" in e)) {
                    _context2.next = 13;
                    break;
                  }

                  _t = 0;

                case 3:
                  if (!(_t < e.length)) {
                    _context2.next = 11;
                    break;
                  }

                  _context2.next = 6;
                  return n()(e[_t], a.html2canvas);

                case 6:
                  _o5 = _context2.sent;
                  s(_o5, i, a);

                case 8:
                  _t++;
                  _context2.next = 3;
                  break;

                case 11:
                  _context2.next = 17;
                  break;

                case 13:
                  _context2.next = 15;
                  return n()(e, a.html2canvas);

                case 15:
                  _t2 = _context2.sent;
                  s(_t2, i, a);

                case 17:
                  _context2.next = 19;
                  return p(i, a);

                case 19:
                  a.success.call(a, i.pdf);
                  return _context2.abrupt("return", i.pdf);

                case 21:
                case "end":
                  return _context2.stop();
              }
            }
          }, c, this);
        }), new ((f = void 0) || (f = Promise))(function (t, e) {
          function n(t) {
            try {
              r(c.next(t));
            } catch (t) {
              e(t);
            }
          }

          function o(t) {
            try {
              r(c.throw(t));
            } catch (t) {
              e(t);
            }
          }

          function r(e) {
            var r;
            e.done ? t(e.value) : (r = e.value, r instanceof f ? r : new f(function (t) {
              t(r);
            })).then(n, o);
          }

          r((c = c.apply(a, i || [])).next());
        });
        var a, i, f, c;
      };
    }(), a.default;
  }();
});